var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.data)?_c('v-card',{attrs:{"flat":""}},[_c('simple-table',[_c('thead',[_c('tr',[_c('th',[_c('router-link',{attrs:{"to":"/sales/returns"}},[_vm._v("Credit Return")])],1),_c('th',[_vm._v(_vm._s(_vm.data.count))]),_c('th',{staticClass:"text-right"},[_vm._v(_vm._s(_vm._f("currency")(_vm.data.amount)))])])])])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }